/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Comparison_Product_Hunt_Rows_Navigation_FeatureInputs */

const en_directory_comparison_product_hunt_rows_navigation_feature = /** @type {(inputs: Directory_Comparison_Product_Hunt_Rows_Navigation_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navigation`)
};

const zh_directory_comparison_product_hunt_rows_navigation_feature = /** @type {(inputs: Directory_Comparison_Product_Hunt_Rows_Navigation_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导航方式`)
};

/**
* | output |
* | --- |
* | "Navigation" |
*
* @param {Directory_Comparison_Product_Hunt_Rows_Navigation_FeatureInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_comparison_product_hunt_rows_navigation_feature = /** @type {((inputs?: Directory_Comparison_Product_Hunt_Rows_Navigation_FeatureInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Comparison_Product_Hunt_Rows_Navigation_FeatureInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_comparison_product_hunt_rows_navigation_feature(inputs)
	return zh_directory_comparison_product_hunt_rows_navigation_feature(inputs)
});
export { directory_comparison_product_hunt_rows_navigation_feature as "directory.comparison.product_hunt.rows.navigation.feature" }